import { createSlice } from "@reduxjs/toolkit";
import { getBanner } from "./bannerApi";

// Slice for managing master doctor state
const bannerSlice = createSlice({
  name: "banner",
  initialState: {
    banner: [],
    loading: false,
    error: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalBanner: 0,
  },
  extraReducers: (builder) => {
    // GET specialties FILTER WISE DATA
    builder.addCase(getBanner.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBanner.fulfilled, (state, action) => {
      state.loading = false;
      state.banner = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalSpecialties = action.payload.meta.total;
    });
    builder.addCase(getBanner.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default bannerSlice.reducer;
